import { createFileRoute } from '@tanstack/react-router';
import { VerificationDetailModule } from '@/modules/promoters/verification/verification-detail';

export const Route = createFileRoute(
  '/dashboard/promoters/verification/$verificationId'
)({
  component: VerificationDetailModule,
});
